<template>
  <div class="result-game-pending t-text">
    <h2>{{ $t('resultView.gamePending.headline') }}</h2>
    <i class="icf-timing timing-icon" />
    <p class="details">{{ $t('resultView.gamePending.details') }}</p>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
@import '~@npm/@gd/common-styles/lib/color-vars';
.result-game-pending {
  margin: 0 auto;
  padding: 2em 3em 0.5em;
  max-width: 34em;
  text-align: center;

  .timing-icon {
    font-size: 3.375rem;
    display: inline-block;
    border-radius: 100%;
    border: 5px solid @c9-g;
    padding: 0rem 0 0;
    width: 5.125rem;
    height: 5.125rem;
    color: @c9-g;
    margin: 0 0.2em;
  }

  .details {
    font-size: 1em;
  }
}
</style>
